"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DimensionSchema = exports.WeightSchema = exports.MeasureSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("../enums");
exports.MeasureSchema = zod_1.z.object({
    value: zod_1.z.number().nonnegative(),
    unit: zod_1.z.nativeEnum(enums_1.EMeasure),
});
exports.WeightSchema = zod_1.z.object({
    value: zod_1.z.number().nonnegative(),
    unit: zod_1.z.nativeEnum(enums_1.EWeight),
});
exports.DimensionSchema = zod_1.z.object({
    length: exports.MeasureSchema.optional(),
    width: exports.MeasureSchema.optional(),
    height: exports.MeasureSchema.optional(),
    weight: exports.WeightSchema.optional(),
});
//# sourceMappingURL=index.js.map